import { GetServerSideProps } from "next";
import Head from "next/head";
import request from '@/utils/request';

const getMenuCurrent = (menu: any[], path: string): any => {
  for (let i = 0; i < menu?.length; i++) {
    const item = menu[i];
    if (item.pathinfo === path) {
      return item;
    }

    if (item.childlist && Array.isArray(item.childlist)) {
      const child = getMenuCurrent(item.childlist, path) as any;
      if (child) {
        return child;
      }
    }
  }

  return null;
}

const getServerSideProps = async (context: any, menuId?: number) => {
  const { data: _menu } = await request.get(`/api/menu`, {
    params: {
      lang: context?.locale || 'cn',
    }
  })
  const menuCurrent = getMenuCurrent(_menu?.data?.menu_tree, context?.resolvedUrl?.split('?')[0])
  const { data: _data } = await request.get(`/api/menu_info/${menuId || menuCurrent?.id}`, {
    params: {
      lang: context?.locale || 'cn',
    }
  });

  return {
    props: {
      menuDetail: _data.data || null,
    },
  };
};

const getHead = (menuDetail: any) => {
  return (
    <Head>
      {
        menuDetail?.info?.meta_title && <title>{menuDetail?.info?.meta_title}</title>
      }
      {
        menuDetail?.info?.meta_kws && <meta name="keywords" content={menuDetail?.info?.meta_kws} />
      }
      {
        menuDetail?.info?.meta_desc && <meta name="description" content={menuDetail?.info?.meta_desc} />
      }
    </Head>
  )
}
export { getHead, getServerSideProps }
